// 吃瓜内容 mock 数据 —— 明星恋情 / 绯闻 / 恋爱爆料编辑部盘点（虚构人物内容，仅供展示）
// 栏目定义
export const CATEGORIES = [
  { key: 'love', label: '恋情公开', desc: '官宣、牵手、公开撒糖的甜蜜现场' },
  { key: 'dating', label: '约会实锤', desc: '被拍、同框、深夜约会的实锤细节' },
  { key: 'breakup', label: '分手复合', desc: '体面告别、破镜重圆的感情走向' },
  { key: 'timeline', label: '感情线盘点', desc: '从相识到官宣的完整恋爱时间线' },
] as const;

export type TagKey = 'love' | 'dating' | 'breakup' | 'timeline';

export interface FeedArticle {
  id: string;
  title: string;
  tag: TagKey;
  summary: string;
  image: string;
  date: string;
  minutes: number;
  heat: number;
  comments: number;
  author: string;
}

export const HERO_SCOOP = {
  kicker: '今日头条瓜',
  title: '深夜同返公寓被拍，顶流男演员与神秘女子恋情疑似实锤',
  summary:
    '狗仔连续三天蹲守到某位正当红的男演员深夜返回同一公寓，随行女子全程低调戴口罩，两人隔天又被拍到先后取快递与遛狗，恋情传闻迅速冲上热搜第一。',
  tags: ['约会实锤', '恋情公开', '深夜同框'],
  date: '2026-09-06',
  heat: '2184万阅读',
  image:
    'https://readdy.ai/api/search-image?query=candid%20flash%20photograph%20of%20a%20glamorous%20mysterious%20young%20celebrity%20couple%20laughing%20while%20walking%20through%20a%20neon%20city%20street%20at%20night%20warm%20cinematic%20rose%20and%20amber%20color%20grading%20motion%20energy%20editorial%20magazine%20cover%20style%20high%20detail%20film%20grain&width=1600&height=900&seq=hero-cover-2026&orientation=landscape',
};

export const HOT_LIST = [
  { rank: 1, title: '顶流男演员与神秘女子深夜同返公寓，疑似新恋情曝光', heat: '2184万', tag: 'dating' },
  { rank: 2, title: '当红小花前任公开喊话，疑似分手后仍有未了心结', heat: '1675万', tag: 'breakup' },
  { rank: 3, title: '同剧组男女主角隔空互动频繁，片场花絮暗藏糖点', heat: '1302万', tag: 'love' },
  { rank: 4, title: '机场同款行李箱被扒，娱乐圈又一对“地下恋”浮出水面', heat: '986万', tag: 'dating' },
  { rank: 5, title: '官宣三个月即低调复合？昔日顶流情侣再被拍到同框', heat: '754万', tag: 'breakup' },
  { rank: 6, title: '相恋五年男团成员恋情时间线复盘，甜到网友集体上头', heat: '603万', tag: 'timeline' },
  { rank: 7, title: '综艺首次同台，两人对视眼神被赞“藏不住的喜欢”', heat: '451万', tag: 'love' },
  { rank: 8, title: '深夜烤肉店同框照流出，饭圈直呼“又是偷偷约会的一天”', heat: '328万', tag: 'dating' },
];

export const FEED_ARTICLES: FeedArticle[] = [
  {
    id: 'a01',
    title: '红毯十指紧扣甜到出圈，这对官宣情侣的糖我先磕为敬',
    tag: 'love',
    summary:
      '颁奖礼红毯上十指紧扣、全程耳语不断，受访时大方回应“是他/她先追的我”。从片场初见到公开认爱，全程细节都被网友逐帧分析，直呼娱乐圈又出神仙爱情。',
    image:
      'https://readdy.ai/api/search-image?query=stylized%20editorial%20portrait%20of%20a%20young%20celebrity%20couple%20holding%20hands%20walking%20a%20red%20carpet%20warm%20rose%20gold%20lighting%20elegant%20magazine%20photography%20soft%20bokeh%20cinematic%20film%20grain%20high%20detail&width=800&height=1000&seq=feed-love-01&orientation=portrait',
    date: '2026-09-05',
    minutes: 6,
    heat: 1200000,
    comments: 3280,
    author: '编辑部',
  },
  {
    id: 'a02',
    title: '片场收工后同车离开，男女主被扒出三个月“隐秘同框”',
    tag: 'dating',
    summary:
      '收工照意外露出同款外套与车牌，网友顺藤摸瓜扒出三个月内两人至少有六次行程重叠，助理全程打掩护。剧组工作人员一句“关系很好”更让恋情传闻甚嚣尘上。',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20night%20scene%20of%20a%20car%20waiting%20outside%20a%20film%20studio%20with%20warm%20amber%20street%20lights%20moody%20editorial%20gossip%20photography%20film%20noir%20atmosphere%20soft%20focus%20rose%20amber%20tone%20high%20detail&width=800&height=1000&seq=feed-dating-01&orientation=portrait',
    date: '2026-09-05',
    minutes: 8,
    heat: 986000,
    comments: 2410,
    author: '一线狗仔组',
  },
  {
    id: 'a03',
    title: '相恋四年终于认爱，长文细节里藏满了普通人式的浪漫',
    tag: 'love',
    summary:
      '一篇不长的认爱长文引爆热搜。没有华丽辞藻，只有一起养猫、逛超市、看凌晨场的日常。网友感叹：原来顶流也想要被好好爱着的普通生活。',
    image:
      'https://readdy.ai/api/search-image?query=soft%20warm%20editorial%20photo%20of%20two%20hands%20feeding%20a%20cat%20together%20by%20a%20sunlit%20window%20cozy%20domestic%20romantic%20mood%20rose%20gold%20grading%20magazine%20aesthetic%20film%20grain%20high%20detail&width=800&height=1000&seq=feed-love-02&orientation=portrait',
    date: '2026-09-04',
    minutes: 5,
    heat: 1500000,
    comments: 4150,
    author: '编辑部',
  },
  {
    id: 'a04',
    title: '深夜烤肉店同框被拍，助理遮遮掩掩更显“此地无银”',
    tag: 'dating',
    summary:
      '烤肉店里并肩而坐、共用一个蘸料碟的画面被路人拍下。两人发现镜头后火速压低帽檐离场，越掩饰越真实，吃瓜网友已经开始坐等下一步官宣。',
    image:
      'https://readdy.ai/api/search-image?query=warm%20cozy%20korean%20bbq%20restaurant%20interior%20at%20night%20two%20young%20people%20sitting%20close%20together%20blurred%20faces%20candid%20spy%20photo%20style%20amber%20mood%20lighting%20editorial%20gossip%20aesthetic%20high%20detail&width=800&height=1000&seq=feed-dating-02&orientation=portrait',
    date: '2026-09-04',
    minutes: 4,
    heat: 875000,
    comments: 1980,
    author: '路人站姐',
  },
  {
    id: 'a05',
    title: '低调官宣两年后首度公开同台，眼神对视直接甜到热搜',
    tag: 'love',
    summary:
      '从不炒作、低调恋爱的一对，首次综艺同台便贡献名场面：讲到对方时忍不住上扬的嘴角，被主持人起哄时的相视一笑。感情最好的模样大概就是藏也藏不住。',
    image:
      'https://readdy.ai/api/search-image?query=bright%20stylish%20television%20studio%20stage%20two%20young%20celebrities%20glancing%20at%20each%20other%20and%20smiling%20warm%20soft%20key%20lighting%20editorial%20magazine%20photography%20rose%20gold%20tone%20film%20grain%20high%20detail&width=800&height=1000&seq=feed-love-03&orientation=portrait',
    date: '2026-09-03',
    minutes: 6,
    heat: 1300000,
    comments: 3560,
    author: '编辑部',
  },
  {
    id: 'a06',
    title: '从官宣到分手的这两年：这条感情线的每一步都有迹可循',
    tag: 'timeline',
    summary:
      '有人相爱，有人深夜删博。结合时间线与公开物料，复盘这对曾经的神仙情侣如何从甜蜜官宣走向体面告别——其实分手早有伏笔，只是当时没人愿意相信。',
    image:
      'https://readdy.ai/api/search-image?query=flat%20lay%20of%20many%20small%20rose%20tinted%20photographs%20and%20polaroids%20of%20couple%20memories%20scattered%20on%20paper%20warm%20editorial%20retrospective%20collage%20style%20rose%20and%20amber%20grading%20high%20detail%20magazine%20feature&width=800&height=1000&seq=feed-time-01&orientation=portrait',
    date: '2026-09-03',
    minutes: 12,
    heat: 703000,
    comments: 1640,
    author: '深度组',
  },
  {
    id: 'a07',
    title: '分手半年后聚餐被拍，前任同框到底算复合还是彻底释怀',
    tag: 'breakup',
    summary:
      '分手后首次同框，两人饭桌上气氛轻松、聊得热络，结束后还各自挥手道别。是旧情复燃还是体面放下？心理学视角告诉你如何读懂前任见面时的微表情。',
    image:
      'https://readdy.ai/api/search-image?query=moody%20dim%20restaurant%20dinner%20scene%20two%20stylish%20people%20talking%20across%20a%20table%20warm%20candle%20light%20soft%20bokeh%20contemplative%20editorial%20gossip%20photography%20rose%20amber%20tone%20film%20grain%20high%20detail&width=800&height=1000&seq=feed-break-01&orientation=portrait',
    date: '2026-09-02',
    minutes: 7,
    heat: 921000,
    comments: 2890,
    author: '一线狗仔组',
  },
  {
    id: 'a08',
    title: '机场同款行李箱只是巧合？整理他七年三段恋情的“物件线索”',
    tag: 'timeline',
    summary:
      '从同款耳机到同款行李箱，网友考古出男星七年来的恋爱“物件密码”。当时间线被一一拼上，那些所谓巧合，原来都是藏不住的喜欢。',
    image:
      'https://readdy.ai/api/search-image?query=sleek%20airport%20departure%20hall%20with%20two%20matching%20suitcases%20standing%20together%20warm%20morning%20light%20cinematic%20editorial%20photography%20rose%20gold%20tone%20soft%20shallow%20depth%20of%20field%20high%20detail&width=800&height=1000&seq=feed-time-02&orientation=portrait',
    date: '2026-09-02',
    minutes: 9,
    heat: 654000,
    comments: 1530,
    author: '深度组',
  },
  {
    id: 'a09',
    title: '情绪稳定的成年人分手：工作室声明里的体面与克制',
    tag: 'breakup',
    summary:
      '没有互撕、没有小作文，一条简短声明为六年感情画上句点。分开后的第一个月，两人依旧各自如常营业。我们聊聊为什么“体面分手”反而最让人意难平。',
    image:
      'https://readdy.ai/api/search-image?query=minimal%20elegant%20studio%20scene%20with%20a%20single%20chair%20and%20soft%20window%20light%20melancholic%20calm%20editorial%20photography%20desaturated%20rose%20and%20cream%20tones%20film%20grain%20quiet%20atmosphere%20high%20detail&width=800&height=1000&seq=feed-break-02&orientation=portrait',
    date: '2026-09-01',
    minutes: 5,
    heat: 748000,
    comments: 2010,
    author: '编辑部',
  },
  {
    id: 'a10',
    title: '破镜重圆：异地恋多年后，这对昔日顶流情侣被拍到复合',
    tag: 'breakup',
    summary:
      '机场互等、同款狗狗挂饰……一个又一个“巧合”暗示旧情复燃。粉丝态度从抗拒到祝福，只用了三天。回顾他们分分合合的感情线，这次能否走到最后？',
    image:
      'https://readdy.ai/api/search-image?query=romantic%20golden%20hour%20silhouette%20of%20two%20people%20meeting%20at%20an%20airport%20walkway%20window%20light%20warm%20rose%20amber%20cinematic%20editorial%20photography%20soft%20glow%20high%20detail%20film%20grain&width=800&height=1000&seq=feed-break-03&orientation=portrait',
    date: '2026-08-31',
    minutes: 8,
    heat: 1130000,
    comments: 3270,
    author: '一线狗仔组',
  },
];

export const LOVE_LINES = [
  {
    celeb: '沈知遇 × 姜若薇',
    coverLabel: '《恋恋春日》剧组',
    totalYears: '3年',
    status: '稳定恋爱中',
    events: [
      { time: '2023 春', text: '同剧进组，因戏结缘，片场互动频繁被拍' },
      { time: '2023 冬', text: '跨年同款围巾首曝，被扒同游冰岛' },
      { time: '2024 夏', text: '男方多次往返女方剧组酒店，绯闻升温' },
      { time: '2025 春', text: '双双现身对方重要场合，家人同框' },
      { time: '2026 秋', text: '感情稳定，婚讯传闻被圈内人间接证实' },
    ],
  },
  {
    celeb: '陆柏舟 × 许清欢',
    coverLabel: '识于微时',
    totalYears: '2年',
    status: '低调认爱',
    events: [
      { time: '2021 秋', text: '同校时期被网友挖出旧照，早有渊源' },
      { time: '2024 初', text: '综艺后台聊天片段流出，被赞相配' },
      { time: '2025 中', text: '被拍共赴好友婚礼，正式传出恋情' },
      { time: '2026 春', text: '低调官宣认爱，长文记录普通浪漫' },
    ],
  },
];

export const FAQS = [
  {
    q: '“约会实锤”通常依据哪些线索判断？',
    a: '编辑部会综合同框影像、行程轨迹、同款物件与时间线重叠来交叉验证。单独一项只能算“巧合”，多项证据互相吻合时，才会用“实锤”的表述，避免无据传播。',
  },
  {
    q: '明星“被拍同框”就一定是恋情吗？',
    a: '不一定。同剧组同事、多年好友聚餐都很常见。我们会结合两人关系背景、拍摄场合与后续反应综合判断，并在内容里明确标注“疑似”或“确认”的不同等级。',
  },
  {
    q: '感情线盘点里的时间节点可靠吗？',
    a: '时间线均来自公开可查的物料：节目播出、社交动态、杂志访谈与已核实的媒体报道，并标注事件来源节点。若当事人事后澄清，我们会第一时间在时间线下更新备注。',
  },
  {
    q: '平台如何处理可能涉及的隐私与不实信息？',
    a: '八卦吃瓜坚持“可确认才报道、当事人澄清即修正”的原则。涉及隐私、未成年人或严重失实的内容一律不上榜，也欢迎当事人或工作室通过文末渠道联系核正。',
  },
  {
    q: '为什么有的瓜看着像“锤”，却标注为“疑似”？',
    a: '图片存在 AI 处理、旧料翻炒等可能。凡无法通过多方验证的素材，我们统一用“疑似”“被指”等词保留谨慎空间，确保不因单张截图误伤他人。',
  },
];

export const POLL = {
  question: '这段“深夜同返公寓”的新恋情瓜，你更站哪个结果？',
  options: [
    { label: '坐等官宣，看着就像真的', percent: 46, votes: 12840 },
    { label: '就是普通朋友/同事', percent: 18, votes: 5020 },
    { label: '先观望，证据还不够硬', percent: 27, votes: 7540 },
    { label: '无所谓，谈恋爱自由', percent: 9, votes: 2500 },
  ],
};

export const VOICES = [
  {
    name: '追星五年的老粉',
    text: '在这里能看到把零散物料整理成完整时间线的深度盘点，比自己去考古省心太多，最关键的是标注了可信度等级，追星终于不迷路了。',
  },
  {
    name: '吃瓜路人甲',
    text: '版面清爽不标题党，该标“疑似”就标“疑似”，不瞎带节奏。下班刷一刷，一天的高强度吃瓜都能补上。',
  },
  {
    name: '娱乐自媒体同行',
    text: '感情线复盘做得很细，时间节点都标了来源，引用起来非常方便，是同类内容里少有的“讲依据”的账号。',
  },
];